export const HISTORY_PREFIX = 'ECM_MENU_SEARCH_HISTORY_V1:'
export const EPHEMERAL_HISTORY_KEY = 'ECM_MENU_SEARCH_EPHEMERAL'
const MAX_HISTORY = 10
const memoryHistory = new Map()
const volatileKeys = new Set()

export function historyKey(identity) {
  if (!identity || !identity.sub || !identity.realm || !identity.authUrl) return ''
  // localStorage 本身按站点隔离，键再按认证域与用户标识隔离。
  return `${HISTORY_PREFIX}${encodeURIComponent(identity.authUrl)}:${encodeURIComponent(identity.realm)}:${encodeURIComponent(identity.sub)}`
}

export function normalizeQuery(query) {
  return String(query || '').trim().replace(/\s+/g, ' ').slice(0, 80)
}

export function readHistory(key) {
  if (!key) return []
  if (key === EPHEMERAL_HISTORY_KEY) return memoryHistory.get(key) || []
  if (volatileKeys.has(key)) return memoryHistory.get(key) || []
  try {
    const stored = JSON.parse(localStorage.getItem(key) || '[]')
    if (!Array.isArray(stored)) return []
    const sanitized = stored.filter(item => item && typeof item.query === 'string' && Number.isFinite(item.usedAt))
      .slice(0, MAX_HISTORY)
      .map(item => ({ query: normalizeQuery(item.query), usedAt: item.usedAt }))
      .filter(item => item.query)
    memoryHistory.set(key, sanitized)
    return sanitized
  } catch (error) {
    return memoryHistory.get(key) || []
  }
}

function saveHistory(key, items) {
  memoryHistory.set(key, items)
  if (key === EPHEMERAL_HISTORY_KEY) return items
  try {
    localStorage.setItem(key, JSON.stringify(items))
  } catch (error) {
    // 隐私模式或存储额度不足时，仅保留当前会话的内存记录。
    volatileKeys.add(key)
  }
  return items
}

export function rememberQuery(key, rawQuery) {
  const query = normalizeQuery(rawQuery)
  if (!key || !query) return []
  const rest = readHistory(key).filter(item => item.query.toLocaleLowerCase() !== query.toLocaleLowerCase())
  return saveHistory(key, [{ query, usedAt: Date.now() }, ...rest].slice(0, MAX_HISTORY))
}

export function deleteQuery(key, query) {
  if (!key) return []
  return saveHistory(key, readHistory(key).filter(item => item.query !== query))
}

export function clearHistory(key) {
  if (!key) return []
  memoryHistory.delete(key)
  if (key === EPHEMERAL_HISTORY_KEY) return []
  volatileKeys.delete(key)
  try {
    localStorage.removeItem(key)
  } catch (error) {
    // 同上，存储不可用不影响搜索。
    volatileKeys.add(key)
  }
  return []
}
